<template>
    <div>
    <navbar/>
    <router-view :key="$route.fullPath" />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
export default {
  components: { Navbar }
}
</script>

<style scoped>
</style>
